import React, { useState, useEffect } from "react";
import { db, } from "../../services/firebaseConfig";
import { collection, onSnapshot, doc, updateDoc, getDoc } from "firebase/firestore";
import AlertMessage from "../../components/AlertMessage";

import "../../styles/OrderForm.css";

function getMinPengurusPriceAny(hargaObj) {
    if (!hargaObj) return "0.00";
    // Kalau terus ada pengurus, terus ambil
    if (typeof hargaObj.pengurus === "number" && hargaObj.pengurus > 0) return hargaObj.pengurus.toFixed(2);
    // Kalau pecah tahun, cari harga minimum
    let min = Infinity;
    Object.values(hargaObj).forEach(val => {
        if (typeof val?.pengurus === "number" && val.pengurus > 0) {
            min = Math.min(min, val.pengurus);
        }
    });
    return min !== Infinity ? min.toFixed(2) : "0.00";
}





const OrderForm = ({ onMenuSelect }) => {
    const [stocks, setStocks] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("Semua");
    const [selectedStock, setSelectedStock] = useState(null);
    const [quantities, setQuantities] = useState({});
    const [showAlert, setShowAlert] = useState(false);


    const sizeOrder = ["XS", "S", "M", "L", "XL", "2XL", "3XL"];
    const yearOrder = ["4 Tahun", "5 Tahun", "6 Tahun"];



    const [orderSetting, setOrderSetting] = useState(null);
    const [orderLoading, setOrderLoading] = useState(true);

    useEffect(() => {
        const settingDoc = doc(db, "inventori", "selangor", "settings", "order");
        const unsub = onSnapshot(settingDoc, (snap) => {
            setOrderSetting(snap.exists() ? snap.data() : null);
            setOrderLoading(false);
        });
        return () => unsub();
    }, []);


    const now = new Date();
    let isOrderOpen = false;
    let msgOrder = "";
    if (orderSetting) {
        const open = orderSetting.isOpen;
        const openDate = orderSetting.openDate?.toDate?.() || null;
        const closeDate = orderSetting.closeDate?.toDate?.() || null;
        isOrderOpen =
            !!open ||
            (!!openDate && !!closeDate && openDate <= now && now <= closeDate);

        if (!isOrderOpen) {
            if (openDate && now < openDate)
                msgOrder = `Tempahan akan dibuka pada ${openDate.toLocaleString("ms-MY", { dateStyle: "medium", timeStyle: "short" })}`;
            else if (closeDate && now > closeDate)
                msgOrder = "Tempahan sudah ditutup.";
            else
                msgOrder = "Maaf, tempahan belum dibuka atau sudah ditutup.";
        }
    }


    // 🔥 Real-time update Firestore
    useEffect(() => {
        const stocksCollection = collection(db, "inventori", "selangor", "stocks");

        const unsubscribe = onSnapshot(stocksCollection, (snapshot) => {
            const updatedStocks = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setStocks(updatedStocks);
        });

        return () => unsubscribe(); // Cleanup listener apabila component unmount
    }, []);

    useEffect(() => {
        if (selectedStock) {
            const updatedStock = stocks.find((stock) => stock.id === selectedStock.id);
            if (updatedStock) {
                setSelectedStock(updatedStock);
            }
        }
    }, [stocks, selectedStock]);


    const handleCategoryChange = (category) => {
        console.log("Kategori dipilih:", category); // 🔥 Debugging output

        setSelectedCategory(category);
        setSelectedStock(null);
    };

    const handleSelectStock = (stock) => {
        setSelectedStock(prevStock => (prevStock?.id === stock.id ? null : stock));
        setQuantities({});
    };

    const handleQuantityChange = (key, value) => {
        const qty = parseInt(value) || 0;
        setQuantities(prev => ({ ...prev, [key]: qty }));
    };

    // 🔥 Fungsi tambah ke troli & kemaskini Firestore
    const addToCart = async () => {
        if (!selectedStock) return;

        const stockRef = doc(db, "inventori", "selangor", "stocks", selectedStock.id);
        const stockSnap = await getDoc(stockRef);
        if (!stockSnap.exists()) return;

        const stockData = stockSnap.data();
        let updatedStockData = {};
        let cartItem = {
            id: selectedStock.id,
            name: selectedStock.name,
            category: selectedStock.category,
            price: selectedStock.harga?.pengurus || 0,

            imageUrl: selectedStock.imageUrl,

        };

        let hasValidQuantity = false;

        if (selectedStock.category === "baju" && selectedStock.sizeQuantities) {
            cartItem.sizes = {};
            cartItem.hargaPerSize = {}; // <-- TAMBAH LINE INI
            updatedStockData.sizeQuantities = { ...stockData.sizeQuantities };

            Object.entries(quantities).forEach(([size, qty]) => {
                if (qty > 0 && stockData.sizeQuantities[size] >= qty) {
                    cartItem.sizes[size] = qty;
                    cartItem.hargaPerSize[size] = selectedStock.harga?.[size]?.pengurus ?? selectedStock.harga?.pengurus ?? 0; // <-- TAMBAH INI
                    updatedStockData.sizeQuantities[size] -= qty;
                    hasValidQuantity = true;
                }
            });
        }
        else if (selectedStock.category === "buku" && selectedStock.yearQuantities) {
            cartItem.years = {};
            cartItem.hargaPerYear = {}; // <-- TAMBAH LINE INI
            updatedStockData.yearQuantities = { ...stockData.yearQuantities };

            Object.entries(quantities).forEach(([year, qty]) => {
                if (qty > 0 && stockData.yearQuantities[year] >= qty) {
                    cartItem.years[year] = qty;
                    cartItem.hargaPerYear[year] = selectedStock.harga?.[year]?.pengurus ?? selectedStock.harga?.pengurus ?? 0; // <-- TAMBAH INI
                    updatedStockData.yearQuantities[year] -= qty;
                    hasValidQuantity = true;
                }
            });
        }
        else if (selectedStock.category === "buku" && selectedStock.quantity !== undefined) {
            let requestedQty = quantities["quantity"] || 0;
            if (requestedQty > 0 && stockData.quantity >= requestedQty) {
                cartItem.quantity = requestedQty;
                updatedStockData.quantity = stockData.quantity - requestedQty;
                hasValidQuantity = true;
            }
        }
        else if (selectedStock.category === "runcit" && selectedStock.quantity !== undefined) {
            let requestedQty = quantities["quantity"] || 0;
            if (requestedQty > 0 && stockData.quantity >= requestedQty) {
                cartItem.quantity = requestedQty;
                updatedStockData.quantity = stockData.quantity - requestedQty;
                hasValidQuantity = true;
            }
        }

        if (!hasValidQuantity) {
            alert("Sila masukkan kuantiti yang sah.");
            return;
        }

        await updateDoc(stockRef, updatedStockData);

        // ✅ Simpan item ke dalam troli (localStorage)
        const storedCart = JSON.parse(localStorage.getItem("cart")) || { items: [], expiryTime: 0 };
        storedCart.items.push(cartItem);
        storedCart.expiryTime = new Date().getTime() + 30 * 60 * 1000; // 🔥 Set masa luput (30 minit)
        localStorage.setItem("cart", JSON.stringify(storedCart));

        setShowAlert(true);

        setTimeout(() => {
            setShowAlert(false);
            onMenuSelect("Cart");
        }, 2000);
        setSelectedStock(null);
    };

    if (orderLoading) return <div>Memuatkan tetapan order...</div>;
    if (!isOrderOpen) return (
        <div style={{ textAlign: "center", color: "#b60c0c", margin: 30, fontWeight: 600, fontSize: "1.2em" }}>
            {msgOrder}
        </div>
    );

    return (
        <div className="order-form-container">
            <AlertMessage message="Produk berjaya ditambah ke troli!" isVisible={showAlert} />

            <div className="category-filter">
                {["Semua", "Baju", "Buku", "Runcit"].map((category) => (
                    <button
                        key={category}
                        className={`category-btn ${selectedCategory === category ? "active" : ""}`}
                        onClick={() => handleCategoryChange(category)}
                    >
                        {category}
                    </button>
                ))}
            </div>

            {selectedStock ? (
                <div className="stock-card expanded">
                    <div className="stock-card-header" onClick={() => setSelectedStock(null)}>
                        {selectedStock.imageUrl && (
                            <img src={selectedStock.imageUrl} alt={selectedStock.name} className="stock-image-expanded" />
                        )}
                        <div className="stock-card-desc">
                            <h3>{selectedStock.name}</h3>
                            {/* Hanya tunjuk harga jika kategori BUKAN baju */}
                            {selectedStock.category === "buku" && !selectedStock.yearQuantities && (
                                <p className="stock-price">
                                    <span style={{ fontSize: "12px" }}>RM </span>
                                    {(selectedStock.harga?.pengurus ?? 0).toFixed(2)}
                                </p>
                            )}
                            {/* Baju & lain */}
                            {selectedStock.category !== "baju" && selectedStock.category !== "buku" && (
                                <p className="stock-price">
                                    <span style={{ fontSize: "12px" }}>RM </span>
                                    {(selectedStock.harga?.pengurus ?? 0).toFixed(2)}
                                </p>
                            )}
                            <p className="stock-desc">{selectedStock.desc}</p>
                        </div>



                    </div>

                    <div className="stock-details">
                        {
                            selectedStock.category === "buku" && selectedStock.yearQuantities ? (
                                Object.entries(selectedStock.yearQuantities || {})
                                    .sort(([a], [b]) => yearOrder.indexOf(a) - yearOrder.indexOf(b))
                                    .map(([year, availableQty]) => (
                                        <div key={year} className="order-item" style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                                            <span style={{ minWidth: 70 }}>{year}</span>
                                            <span style={{
                                                color: "lightcoral", fontWeight: 600, margin: "0 12px 0 8px", minWidth: 80
                                            }}>
                                                <span style={{ fontSize: "12px" }}>RM </span>
                                                {Number(selectedStock.harga?.[year]?.pengurus || 0).toFixed(2)}
                                            </span>
                                            <span style={{ color: "#5ec9bb", fontWeight: 600, marginRight: 8 }}>Stok:</span>
                                            <span style={{ color: "#5ec9bb", fontWeight: 600, width: 36 }}>{availableQty}</span>
                                            <input
                                                type="number"
                                                min="0"
                                                max={availableQty}
                                                value={quantities[year] || ""}
                                                onChange={(e) => handleQuantityChange(year, e.target.value)}
                                                style={{ marginLeft: 12, flex: 1 }}
                                            />
                                        </div>
                                    ))
                            ) : selectedStock.category === "baju" ? (
                                Object.entries(selectedStock.sizeQuantities || {})
                                    .sort(([a], [b]) => {
                                        const indexA = sizeOrder.indexOf(a.toUpperCase());
                                        const indexB = sizeOrder.indexOf(b.toUpperCase());
                                        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
                                    })
                                    .map(([size, availableQty]) => (
                                        <div key={size} className="order-item" style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                                            <span style={{ minWidth: 40 }}>{size}</span>
                                            <span style={{ color: "lightcoral", fontWeight: 600, margin: "0 12px 0 8px", minWidth: 80 }}>
                                                <span style={{ fontSize: "12px" }}>RM </span>{Number(selectedStock.harga?.[size]?.pengurus || 0).toFixed(2)}
                                            </span>
                                            <span style={{ color: "#5ec9bb", fontWeight: 600, marginRight: 8 }}>Stok:</span>
                                            <span style={{ color: "#5ec9bb", fontWeight: 600, width: 36 }}>{availableQty}</span>
                                            <input
                                                type="number"
                                                min="0"
                                                max={availableQty}
                                                value={quantities[size] || ""}
                                                onChange={(e) => handleQuantityChange(size, e.target.value)}
                                                style={{ marginLeft: 12, flex: 1 }}
                                            />
                                        </div>
                                    ))
                            ) : selectedStock.category === "runcit" ? (
                                <div className="order-item">
                                    <span>Stok: {selectedStock.quantity}</span>
                                    <input
                                        type="number"
                                        min="0"
                                        max={selectedStock.quantity}
                                        value={quantities["quantity"] || ""}
                                        onChange={(e) => handleQuantityChange("quantity", e.target.value)}
                                    />
                                </div>
                            ) : (
                                <p>Tiada kuantiti tersedia</p>
                            )}
                    </div>
                    {selectedStock.category === "buku" && !selectedStock.yearQuantities && (
                        <div style={{ display: "flex", alignItems: "center", margin: "12px 0" }}>
                            <label style={{ marginRight: 12 }}>Kuantiti:</label>
                            <span style={{ marginLeft: 16, color: "#5ec9bb", fontWeight: 600 }}>Stok: {selectedStock.quantity || 0}</span>

                            <input
                                type="number"
                                min="0"
                                max={selectedStock.quantity || 0}
                                value={quantities["quantity"] || ""}
                                onChange={(e) => handleQuantityChange("quantity", e.target.value)}
                                style={{ width: 100 }}
                            />
                        </div>
                    )}
                    <div className="group-btn">
                        <div className="close-btn" onClick={() => setSelectedStock(null)}>
                            Tutup
                        </div>
                        <button onClick={addToCart} className="add-to-cart-btn">Masuk Troli</button>
                    </div>
                </div>
            ) : (
                <div className="stock-list-order">
                    {stocks
                        .filter(stock => selectedCategory === "Semua" || stock.category.toLowerCase() === selectedCategory.toLowerCase())
                        .sort((a, b) => (a.priority ?? 9999) - (b.priority ?? 9999))
                        .map((stock) => (
                            <div key={stock.id} className="stock-card" onClick={() => handleSelectStock(stock)}>
                                {stock.imageUrl && <img src={stock.imageUrl} alt={stock.name} className="stock-image" />}
                                <h3>{stock.name}</h3>
                                <p className="stock-price">
                                    <span style={{ fontSize: "12px" }}>RM </span>
                                    {["baju", "buku"].includes(stock.category)
                                        ? getMinPengurusPriceAny(stock.harga)
                                        : (stock.harga?.pengurus ?? 0).toFixed(2)
                                    }
                                </p>

                            </div>
                        ))}
                </div>
            )}
        </div>
    );
};

export default OrderForm;
